<template>
  <div class="fill-height grey lighten-4">
    <div
      class="secondary-appbar cardTitle d-flex align-center"
      v-if="Object.keys(this.evaluation()).length !== 0"
    >
      <v-container>
        <v-row no-gutters="" justify="space-between" align="center">
          <v-col cols="auto">
            <p class="text-uppercase">
              ENCUESTA ESTADO EMOCIONAL DURANTE PANDEMIA ESTUDIANTES 1
            </p>
          </v-col>
          <v-col cols="auto">
            <v-btn rounded class="text-capitalize" @click.prevent="back()">
              <img src="@/assets/images/back.svg" alt="" />
              <span class="ml-3">Volver</span>
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
    </div>
    <v-container fluid v-if="Object.keys(this.evaluation()).length !== 0">
      <v-row>
        <!-- Pdf Reader wrapper -->
        <v-col class="pdf-wrapper" cols="12" sm="12" md="7" lg="8">
          <EvaluationPdfReader
            :pdfDoc="`https://dev.romaevalua.cl/pdf/${idMedicion}`"
          />
        </v-col>
        <!-- Evaluation wrapper -->
        <v-col cols="12" sm="12" md="5" lg="4" class="evaluation-wrapper">
          <v-card class="evaluation-component">
            <v-card-text>
              <EvaluationQuiz />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-container v-else>
      <v-row justify="center">
        <v-col cols="12">
          <v-alert dense text type="error" border="left">
            No se puede mostrar detalles de esta evaluación.
          </v-alert>
        </v-col>
        <v-col cols="12">
          <div
            style="display: flex; flex-direction: row; justify-content: center"
          >
            <img alt="error-img" src="@/assets/images/error.svg" width="350" />
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="2">
          <v-btn
            rounded
            class="text-capitalize"
            @click.prevent="back()"
            style="width: 100%"
          >
            <img src="@/assets/images/back.svg" alt="" />
            <span class="ml-3">Volver</span>
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import EvaluationPdfReader from "@/components/evaluation/EvaluationPdfReader";
import EvaluationQuiz from "@/components/evaluation/EvaluationQuiz";
export default {
  components: {
    EvaluationPdfReader,
    EvaluationQuiz,
  },
  created() {
    // console.log('Estoy creado');
    // console.log(this.$route.query);
    this.detailsEvaluation(this.$route.query);
  },
  data() {
    return {
      idMedicion: 18574,
    };
  },
  methods: {
    ...mapActions({
      detailsEvaluation: "detailsEvaluation",
    }),
    ...mapGetters({
      institucionId: "getInstitutionId",
      user: "getUserData",
      evaluation: "getEvaluationDetail",
    }),
    back() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
$secondary-appbar-w: 55.5px;
.roma-page-content {
  position: relative;
  .secondary-appbar {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: $secondary-appbar-w;
  }
  .evaluation-content {
    // margin-top: $secondary-appbar-w;
  }
  .evaluation-wrapper {
  }
  .pdf-wrapper {
    min-height: calc(100vh - 120px);
  }
  .evaluation-component {
    height: 100%;
  }
  &.EvaluationDetail {
    padding: $secondary-appbar-w 0 0 0;
    & > .container {
      max-width: 100% !important;
    }
  }
}
.evaluation-title {
  color: blue;
}
</style>
